import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const DocumentTemplatesPage_List_AllDocumentTemplates_QueryDocument =
  graphql(`
    query DocumentTemplatesPage_List_AllDocumentTemplates_Query {
      findAllDocumentTemplates {
        _id
        code
        label
        document {
          title
          typeId
        }
        statusId
      }
    }
  `);

export type DocumentTemplatesPage_List_DocumentTemplate = ResultOf<
  typeof DocumentTemplatesPage_List_AllDocumentTemplates_QueryDocument
>['findAllDocumentTemplates'][number];

export const useFindAllDocumentTemplatesQuery = () =>
  useGraphQLQuery(
    DocumentTemplatesPage_List_AllDocumentTemplates_QueryDocument,
  );
